import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "leaflet/dist/leaflet.css";
import "./index.css";

import { Amplify } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import App from "./App.jsx";
import HomePage from "./pages/HomePage.jsx";
// import BrokerageRanking from "./pages/BrokerageRanking.jsx";
import SearchPage from "./pages/SearchPage.jsx";
import BrokerageDetail from "./pages/BrokerageDetail.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      region: "us-east-1",
      userPoolId: "us-east-1_8jgQmSR2e",
      userPoolClientId: "1nmp730e48j8okdib94q4hnh3",
      authenticationFlowType: "USER_PASSWORD_AUTH",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Simple login check — you can replace with context or Redux later
const isAuthenticated = !!localStorage.getItem("authToken");

root.render(
  <React.StrictMode>
    <Authenticator.Provider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />}>
            {/* Public Route */}
            <Route index element={<HomePage />} />

            {/* Protected Routes */}
            <Route
              element={<ProtectedRoute isAuthenticated={isAuthenticated} />}
            >
              {/* <Route path="brokerage-ranking" element={<BrokerageRanking />} /> */}
              <Route path="search" element={<SearchPage />} />
              <Route path="brokerage/:id" element={<BrokerageDetail />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </Authenticator.Provider>
  </React.StrictMode>
);
